export default "__VITE_ASSET__DvojZTck__"